import { render, staticRenderFns } from "./DepartamentosDoFornecedor.vue?vue&type=template&id=344c1246&scoped=true"
import script from "./DepartamentosDoFornecedor.vue?vue&type=script&lang=js"
export * from "./DepartamentosDoFornecedor.vue?vue&type=script&lang=js"
import style0 from "./DepartamentosDoFornecedor.vue?vue&type=style&index=0&id=344c1246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344c1246",
  null
  
)

export default component.exports